import VimeoEmbed from '@/components/ui/VimeoEmbed'
import YouTubeEmbed from '@/components/ui/YouTubeEmbed'
import type { Project } from '@/types'

interface ProjectHeroProps {
  project: Project
  showVideo?: boolean
}

export default function ProjectHero({ project, showVideo = true }: ProjectHeroProps) {
  const hasVimeoVideo = showVideo && project.previewVideoId !== ''
  const youtubeVideoId = showVideo ? project.youtubeVideoId : undefined

  return (
    <div className="w-full">
      <h1 className="text-display text-text-primary mb-8">{project.name}</h1>
      {hasVimeoVideo && (
        <div
          className="w-full aspect-video rounded-card overflow-hidden"
          style={{ background: project.thumbnailGradient }}
        >
          <VimeoEmbed videoId={project.previewVideoId} autoplay muted className="rounded-none" />
        </div>
      )}
      {youtubeVideoId && <YouTubeEmbed videoId={youtubeVideoId} />}
      {!hasVimeoVideo && !youtubeVideoId && project.thumbnailImage && (
        <div className="relative w-full aspect-video rounded-card overflow-hidden">
          <img
            src={project.thumbnailImage}
            alt={project.name}
            width={1280}
            height={720}
            loading="eager"
            fetchPriority="high"
            decoding="async"
            className="w-full h-full object-cover"
          />
        </div>
      )}
    </div>
  )
}
